import $ from 'jquery'
import Swiper from 'swiper/bundle'
import { Alert } from '../functions'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'

const object = vnObject

const submitOfferFormSlider = new Swiper('.js-submit-offer-form-slider', {
  slidesPerView: 1,
  allowTouchMove: false,
  pagination: {
    el: '.swiper-pagination',
    renderBullet: function (index, className) {
      return (
        '<span class="' +
        className +
        '"><i class="vn-icons-wheel"></i>' +
        (index + 1) +
        '</span>'
      )
    },
  },
})

submitOfferFormSlider.on('slideChange', function () {
  $('.prev-pagination-active').removeClass('prev-pagination-active')
  $('.swiper-pagination-bullet-active')
    .prevAll()
    .addClass('prev-pagination-active')
})

$('.js-form-prev').on('click', function () {
  submitOfferFormSlider.slidePrev()
})

$('.js-calendar').on('click', function () {
  $('.js-start-date').trigger('click')
})

$(document).ready(function () {
  //setup before functions
  var typingTimer //timer identifier
  var doneTypingInterval = 2000 //time in ms, 2 second for example
  var $input = $('.js-corp-input')

  //on keyup, start the countdown
  $input.on('keyup', function () {
    clearTimeout(typingTimer)
    typingTimer = setTimeout(doneTyping, doneTypingInterval)
  })
  //on keydown, clear the countdown
  $input.on('keydown', function () {
    clearTimeout(typingTimer)
  })

  //user is "finished typing," do something
  function doneTyping() {
    var corporateIdentifier = jQuery('.js-corp-input').val()
    var schoolId = jQuery('.js-school-id').val()

    var formData = new FormData()
    formData.append('corporate_identifier', corporateIdentifier)
    formData.append('school_id', schoolId)
    formData.append('action', 'vn_get_company_by_corporate_identifier')

    jQuery.ajax({
      type: 'POST',
      url: object.ajaxUrl,
      data: formData,
      contentType: false,
      processData: false,
      dataType: 'json',
      beforeSend: function () {
        $('.js-offer-form-loader').css('visibility', 'visible')
      },
      success: (res) => {
        if (res.data.company) {
          $('.js-corp-name').val(res.data.company.corporateName)
          $('.js-address').val(res.data.company.address)
          $('.js-zip').val(res.data.company.postalCode)
          $('.js-city').val(res.data.company.city)
        }
      },
      complete: function () {
        $('.js-offer-form-loader').css('visibility', 'hidden')
      },
    })
  }
})

const submitOfferCompanyForm = $('.submit-offer-company-form')

if (submitOfferCompanyForm.length) {
  submitOfferCompanyForm.parsley().on('form:success', function () {
    submitOfferCompanyForm.attr('data-success', 'true')
  })

  submitOfferCompanyForm.parsley().on('form:error', function () {
    submitOfferCompanyForm.attr('data-success', 'false')
  })

  submitOfferCompanyForm.on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $form = $(this)

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: $form.serialize() + '&action=' + 'vn_company_register',
      beforeSend: () => {
        $form.addClass('sending')
        Alert('warning', object.formWait, false)
      },
      success: (res) => {
        $form.removeClass('sending')
        Alert(res.success, res.data.message)
        if (res.data.succes) {
          $('.js-company-id').attr('value', res.data.company_id)
          submitOfferFormSlider.slideNext()
        }
      },
      error: (res) => {
        $form.removeClass('sending')

        Alert(res.error, res.data.message)
      },
    })
  })
}

const submitOfferContactForm = $('.submit-offer-contact-form')

if (submitOfferContactForm.length) {
  submitOfferContactForm.parsley().on('form:success', function () {
    submitOfferContactForm.attr('data-success', 'true')
  })

  submitOfferContactForm.parsley().on('form:error', function () {
    submitOfferContactForm.attr('data-success', 'false')
  })

  submitOfferContactForm.on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $form = $(this)

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: $form.serialize() + '&action=' + 'vn_contact_profile_register',
      beforeSend: () => {
        $form.addClass('sending')
        Alert('warning', object.formWait, false)
      },
      success: (res) => {
        $form.removeClass('sending')
        Alert(res.success, res.data.message)
        if (res.data.succes) {
          $('.js-contact-id').attr('value', res.data.contact_id)
          submitOfferFormSlider.slideNext()
        }
      },
      error: (res) => {
        $form.removeClass('sending')

        Alert(res.error, res.data.message)
      },
    })
  })
}

const submitOfferOfferForm = $('.submit-offer-offer-form')

if (submitOfferOfferForm.length) {
  submitOfferOfferForm.parsley().on('form:success', function () {
    submitOfferOfferForm.attr('data-success', 'true')
  })

  submitOfferOfferForm.parsley().on('form:error', function () {
    submitOfferOfferForm.attr('data-success', 'false')
  })

  submitOfferOfferForm.on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $form = $(this)
    const formData = new FormData($(this)[0])
    formData.append('action', 'vn_offer_register')

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: formData,
      processData: false,
      contentType: false,
      beforeSend: () => {
        $form.addClass('sending')
        Alert('warning', object.formWait, false)
      },
      success: (res) => {
        $form.removeClass('sending')

        if (res.success && res.data.redirect) {
          window.location = res.data.redirect
        }

        Alert(res.success, res.data.message)

        if (res.data.succes) {
          $('.js-contact-id').attr('value', res.data.contact_id)
          submitOfferFormSlider.slideNext()
        }
      },
      error: (res) => {
        $form.removeClass('sending')

        Alert(res.error, res.data.message)
      },
    })
  })
}

$('.vn-file-input').on('change', function () {
  var fileValParts = $(this).val().split('\\')
  $(this)
    .parent()
    .find('.js-file-container')
    .html(fileValParts[fileValParts.length - 1])
})

$('.js-training-branch-select').on('change', function () {
  $('.js-searched-training').css('display', 'block')
  var trainingBranchId = String($(this).find('option:selected').data('id'))
  $('.js-searched-training').each(function () {
    var dataCategories = $(this).data('categories')
    if (dataCategories != undefined) {
      dataCategories = String(dataCategories).split(',')

      if (!dataCategories.includes(trainingBranchId)) {
        $(this).css('display', 'none')
      }
    }
  })
})
